export default __webpack_public_path__ + "static/media/344.7d1c401c.png";